export default __webpack_public_path__ + "static/media/hamburguer_ico.6ca16da1.svg";